import type { DropDownListChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import type { GridFilterCellProps } from "@tql/ui-components-react/kendo/grid";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";

import { daysConstant } from "../../../../utils/constants.ts";

const ALL_ITEM = { text: "All", value: 0 } as const;
const items = [ALL_ITEM, ...daysConstant];

/**
 * Filter cell for the "Days In Advance" column. Renders a dropdown of the
 * five valid values (plus an "All" reset option) instead of the default
 * numeric text input, since the field only accepts a small fixed set.
 */
export const DaysInAdvanceFilterCell = (props: GridFilterCellProps) => {
	const selected = items.find((item) => item.value === props.value) ?? ALL_ITEM;

	const handleChange = (event: DropDownListChangeEvent) => {
		const item = event.value as { value: number };
		const isCleared = item.value === 0;
		props.onChange({
			value: isCleared ? null : item.value,
			operator: isCleared ? "" : "eq",
			syntheticEvent: event.syntheticEvent,
		});
	};

	return (
		// Mirror Kendo's default filter cell wrappers so the TraxGrid
		// search-icon injector and filter-tab navigation hooks keep working.
		<div className={"k-filtercell filter-cell-padded"}>
			<div className={"k-filtercell-wrapper"}>
				<DropDownList
					aria-label={"Filter days in advance"}
					data={items}
					dataItemKey={"value"}
					onChange={handleChange}
					textField={"text"}
					value={selected}
				/>
			</div>
		</div>
	);
};
